import { useState, useRef } from "react";

import { adminEndpoints } from "../../api/endpoints";

export const copyToClipboard = async (str) => {
  try {
    await navigator.clipboard.writeText(str);
  } catch (error) {
    console.warn(`String '${str}' could not be copied to clipboard: ${error}`);
  }
};

export default function useSshTunnel(apiClient, showMsg = null) {
  // chosen device for ssh tunnel
  const [chosenSshClientIds, setChosenSshClientIds] = useState([]);
  const lastSshTunnel = useRef(null);

  const sshTunnel = async (
    clientId,
    onSuccess = null,
    onError = null,
    onFinished = null,
    portForwarding = false,
  ) => {
    let connectionStr = null;
    try {
      const response = await apiClient.post(
        adminEndpoints.clientsshtunnel,
        null,
        { client_id: clientId },
      );
      const { host, port, user } = response.data; // Axios automatically parses JSON
      connectionStr = portForwarding
        ? `ssh -L 9090:localhost:8080 ${user}@${host} -p ${port}`
        : `ssh -p ${port} ${user}@${host}`;
      await copyToClipboard(connectionStr);
      onSuccess?.();
    } catch (error) {
      console.warn('Error in "client:sshTunnel"', error, error.stack);
      onError?.();
    } finally {
      onFinished?.();
    }
    return connectionStr;
  };

  const startTunnel = async (clientId, event) => {
    if (event.altKey) {
      if (lastSshTunnel.current) copyToClipboard(lastSshTunnel.current);
      return; // option / alt
    }
    setChosenSshClientIds((l) => [...l, clientId]);
    lastSshTunnel.current = await sshTunnel(
      clientId,
      () => showMsg?.("Der SSH-Tunnel wurde geöffnet."),
      () => showMsg?.("Der Tunnel konnte nicht geöffnet werden.", "error"),
      () => setChosenSshClientIds((l) => l.filter((i) => i !== clientId)),
      event.ctrlKey || event.metaKey, // strg ; cmd/windows
    );
  };

  return {
    chosenSshClientIds,
    startTunnel,
  };
}
